import React from 'react'
import { useAuth } from '../../contexts/auth-context'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { GlobalStyles } from 'twin.macro'
import { Global } from '@emotion/react'
import { baseStyles } from './styles'
import { Header, Footer } from '.'
import { useFullscreen } from '../../contexts/screen-context'

// Routes that own a full-bleed canvas/workspace and should NEVER paint the
// Header/Footer — regardless of the fullscreen toggle. Previously the chrome
// was hidden via `isFullscreen`, but pressing Esc on these pages toggled
// fullscreen off and the footer flashed back in. Anchoring on pathname is
// stable.
const IMMERSIVE_PATH_PREFIXES = ['/edit', '/canvas', '/viewer', '/studio']

const isImmersivePath = (pathname) =>
  IMMERSIVE_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/') || pathname === p.replace(/\/$/, ''))

const Layout = ({ children }) => {
  const { isFullscreen, margin } = useFullscreen()
  const { isAuthenticated } = useAuth()
  const location = useLocation()
  // auth-context.js handles unauthenticated redirect (4s postMessage timeout → staffing login)

  // Allow scrolling for 'designs' page even if isFullscreen was set from previous navigation
  const isDesignsPage = margin === 'designs'
  const shouldBlockScroll = isFullscreen && !isDesignsPage
  const immersive = isImmersivePath(location.pathname)

  const mainStyle = {
    height: shouldBlockScroll ? '100vh' : 'auto',
    width: shouldBlockScroll ? '100vw' : 'auto',
    overflow: shouldBlockScroll ? 'hidden' : 'visible',
  }

  return (
    <>
      <GlobalStyles />
      <Global styles={baseStyles} />
      {isAuthenticated && !shouldBlockScroll && !isDesignsPage && !immersive && <Header />}
      <main
        id="main"
        className={`relative ${shouldBlockScroll ? 'fixed inset-0 z-50' : 'max-w-full'}`}
        tabIndex={-1}
        style={mainStyle}
      >
        {children}
      </main>
      {isAuthenticated && !shouldBlockScroll && !isDesignsPage && !immersive && margin !== 'canvas' && <Footer />}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
